import { Link, SlideDown, SlideOut, CounterBadge } from '@globalmed/atlas-ui';
import { useState } from 'react';
import { NotificationsBody } from './components/NotificationsBody';
import { NotificationsHeader } from './components/NotificationsHeader';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { useNotificationsStore } from '@/stores/notifications';

export const Notifications = () => {
  const [notificationOpen, setNotificationOpen] = useState(false);
  const { readAllNotifications, notifications } = useNotificationsStore(
    (state) => ({
      notifications: state.getAppointmentNotifications(),
      readAllNotifications: state.readAllNotifications,
    }),
  );
  const isSmallScreen = useMediaQuery('(max-width: 600px)');

  const handleOpenChange = (value: boolean) => {
    if (!value) {
      void readAllNotifications();
    }
    setNotificationOpen(value);
  };

  const Slide = isSmallScreen ? SlideDown : SlideOut;

  return (
    <>
      <CounterBadge
        count={notifications.filter((item) => !item.readAt).length}
        color="error"
        size="sm"
        sx={{
          margin: '20px 20px 0 0',
        }}
        maxView={99}
      >
        <Link
          preIcon="Bell"
          color="grey"
          onClick={() => setNotificationOpen(true)}
        />
      </CounterBadge>
      <Slide
        open={notificationOpen}
        onOpenChange={handleOpenChange}
        title={<NotificationsHeader />}
        body={<NotificationsBody onClose={() => handleOpenChange(false)} />}
      />
    </>
  );
};
